import {
    GET_ROLE,
    SET_ROLE,
    SET_STAGE,
    SET_CANCEL,
    SET_EMPLOYEE_VALIDATIONDATA,
    EMPLOYEE_VALIDATION_SUCCESS,
    EMPLOYEE_VALIDATION_ERROR,
    RESET_EMPLOYEE_DATA,
    SET_CARD_NUMBER_DATA,
    SAVE_EMPLOYEE_ACCOUNT_FORM_SUCCESS_MESSAGE,
    SAVE_EMPLOYEE_ACCOUNT_FORM_WARNING_MESSAGE,
    SAVE_EMPLOYEE_ACCOUNT_FORM_INFO_MESSAGE,
    SAVE_EMPLOYEE_DISCOUNT_FORM_INFO_MESSAGE,
    SAVE_EMPLOYEE_ACCOUNT_FORM_ERROR_MESSAGE,
    GET_ZIPCODE,
    SET_ZIPCODE,
    RESET_ZIPCODE,
    ZIPCODE_ERROR_MESSAGE,
    ZIPCODE_SUCCESS_MESSAGE,
    SAVE_EMPLOYEE_DISCOUNT_FORM,
    SAVE_EMPLOYEE_DISCOUNT_FORM_SUCCESS_MESSAGE,
    SAVE_EMPLOYEE_DISCOUNT_FORM_ERROR_MESSAGE,
    SET_OPTIONAL_FORM_DATA,
    SET_APIMKEY, GET_APIMKEY,
    SET_STEP1_STATUS,
    SET_STEP2_STATUS,
    SET_STEP3_STATUS,
    SET_TOTAL_ATTEMPT,
    SET_OTP,
    IS_FIRST_OTP_SEND,
    SAVE_EMPLOYEE_OTP_FORM_SUCCESS_MESSAGE,
    SAVE_EMPLOYEE_OTP_FORM_ERROR_MESSAGE,
    SAVE_EMPLOYEE_GET_OTP_FORM_SUCCESS_MESSAGE,
    SAVE_EMPLOYEE_GET_OTP_FORM_ERROR_MESSAGE,
    SET_STEP3_SKIP

} from "./employeeDiscountFormAction";

const initialState = {
    role: "",
    stage: 1,
    cancel: 0,
    isFirstOtpSend: 0,
    isStep1Validate: 0,
    isStep2Validate: 0,
    isStep3Validate: 0,
    isStep4Validate: 0,
    isSkipStep3: 0,
    totalAttempt: 0,
    empData: {},
    accData: {},
    optData: {},
    otpData: {},
    zipCodeData: {},
    s1Message: ``,
    s2Message: ``,
    s3Message: ``,
    s4Message: ``,
    s5Message: ``,
    otpMessage: ``,
    s1ResponseStatus: 0, // s1ResponseStatus 0 means pending, 1 means success, 2 error
    s2ResponseStatus: 0, // S2ResponseStatus 0 means pending, 1 means success, 2 error
    s3ResponseStatus: 0, // S2ResponseStatus 0 means pending, 1 means success, 2 error
    s4ResponseStatus: 0, // s4ResponseStatus 0 means pending, 1 means success, 2 error
    s2WarningStatus: 0,
    s4InfoStatus:0,
    s2InfoStatus: 0,
    submitMessage: "",
    submitResponseStatus: 0,
    otpResponse: 0
};
const employeeDiscountForm = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROLE:
            return Object.assign({}, state, {
                role: action.value,
            });
        case SET_ROLE:
            return Object.assign({}, state, {
                role: action.value,
            });
        case SET_STEP3_SKIP:
            return Object.assign({}, state, {
                isSkipStep3: action.value,
            });
        case SET_TOTAL_ATTEMPT:
            return Object.assign({}, state, {
                totalAttempt: action.value,
            });

        case SET_STEP1_STATUS:
            return Object.assign({}, state, {
                isStep1Validate: action.value,
            });
        case SET_STEP2_STATUS:
            return Object.assign({}, state, {
                isStep2Validate: action.value,
            });
        case SET_STEP3_STATUS:
            return Object.assign({}, state, {
                isStep3Validate: action.value,
            });
        case GET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value
            })
        case SET_APIMKEY:
            return Object.assign({}, state, {
                key: action.value,
                dashboardUrl: action.url,
            })

        case SET_STAGE:
            return Object.assign({}, state, {
                stage: action.value,
            });
        case SET_CANCEL:
            return Object.assign({}, state, {
                cancel: action.value,
            });

        case SET_EMPLOYEE_VALIDATIONDATA:
            return Object.assign({}, state, {
                empData: action.value,
            });
        case EMPLOYEE_VALIDATION_SUCCESS:
            return {
                ...state,
                s1Message: action.value,
                s1ResponseStatus: 1,
            };
        case EMPLOYEE_VALIDATION_ERROR:
            return {
                ...state,
                s1Message: action.value,
                s1ResponseStatus: 2,
            };
        case RESET_EMPLOYEE_DATA:
            switch (action.step) {
                case "step1":
                    if (action.keyToReset === 0) {
                        // for complete reset step1 data
                        return {
                            ...state,
                            empData: {},
                            s1Message: ``,
                            s1ResponseStatus: 0,
                        };
                    }

                    if (action.keyToReset === 1) {
                        // for  reset message from step1 data
                        return {
                            ...state,
                            s1Message: ``,
                        };
                    }

                    if (action.keyToReset === 2) {
                        // for  reset status response from step1 data
                        return {
                            ...state,
                            s1ResponseStatus: 0,
                        };
                    }

                    if (action.keyToReset === 3) {
                        // for  reset empData object from step1 data
                        return {
                            ...state,
                            empData: {},
                        };
                    }
                    break;
                case "step2":
                    if (action.keyToReset === 0) {
                        // for complete reset step1 data
                        return {
                            ...state,
                            accData: {},
                            s2Message: ``,
                            s2ResponseStatus: 0,
                            s2WarningStatus: 0,
                            s2InfoStatus: 0
                        };
                    }

                    if (action.keyToReset === 1) {
                        // for  reset message from step1 data
                        return {
                            ...state,
                            s2Message: ``,
                        };
                    }

                    if (action.keyToReset === 2) {
                        // for  reset status response from step1 data
                        return {
                            ...state,
                            s2ResponseStatus: 0,
                        };
                    }

                    if (action.keyToReset === 3) {
                        // for  reset empData object from step1 data
                        return {
                            ...state,
                            accData: {},
                        };
                    }
                    if (action.keyToReset === 4) {
                        return {
                            ...state,
                            s2InfoStatus: 0,
                        };
                    }
                    break;
                case "step3":
                    if (action.keyToReset === 0) {
                        // for complete reset step1 data
                        return {
                            ...state,
                            otpData: {},
                            s3Message: ``,
                            s3ResponseStatus: 0,
                            otpResponse: 0,
                            otpMessage: ``
                        };
                    }

                    if (action.keyToReset === 1) {
                        // for  reset message from step1 data
                        return {
                            ...state,
                            s3Message: ``,
                            otpMessage: ``,
                        };
                    }

                    if (action.keyToReset === 2) {
                        // for  reset status response from step1 data
                        return {
                            ...state,
                            s3ResponseStatus: 0,
                        };
                    }

                    if (action.keyToReset === 3) {
                        // for  reset empData object from step1 data
                        return {
                            ...state,
                            otpData: {},
                        };
                    }
                    if (action.keyToReset === 4) {
                        // for complete reset step1 data
                        return {
                            ...state,

                            otpResponse: 0,
                            otpMessage: ``
                        };
                    }
                    break;
                case "step4":
                    if (action.keyToReset === 0) {
                        // for complete reset step1 data
                        return {
                            ...state,
                            optData: {},
                            zipCodeData: {},
                            s4Message: ``,
                            s4ResponseStatus: 0,
                            submitMessage: "",
                            submitResponseStatus: 0,
                            s4InfoStatus:0,
                            s5Message: ``,
                        };
                    }

                    if (action.keyToReset === 1) {
                        // for  reset message from step1 data
                        return {
                            ...state,
                            s4Message: ``,
                            submitMessage: ``,
                        };
                    }

                    if (action.keyToReset === 2) {
                        // for  reset status response from step1 data
                        return {
                            ...state,
                            s4ResponseStatus: 0,
                            submitResponseStatus: 0,
                        };
                    }
                    if (action.keyToReset === 4) {
                        // for  reset status response from step1 data
                        return {
                            ...state,
                            s4InfoStatus:0,
                            s5Message: ``,
                        };
                    }

                    if (action.keyToReset === 3) {
                        // for  reset empData object from step1 data
                        return {
                            ...state,
                            optData: {},
                        };
                    }
                    break;
                default:
                    return state;
            }
            break;
        case SET_CARD_NUMBER_DATA:
            return Object.assign({}, state, {
                accData: action.value,
            });
        case SET_OTP:
            return Object.assign({}, state, {
                otpData: action.value,
            });
        case IS_FIRST_OTP_SEND:
            return Object.assign({}, state, {
                isFirstOtpSend: action.value,
            });
        case SAVE_EMPLOYEE_OTP_FORM_SUCCESS_MESSAGE:
            return Object.assign({}, state, {
                s3Message: action.value,
                s3ResponseStatus: 1,
            });
        case SAVE_EMPLOYEE_OTP_FORM_ERROR_MESSAGE:
            return Object.assign({}, state, {
                s3Message: action.value,
                s3ResponseStatus: 2,
            });
        case SAVE_EMPLOYEE_GET_OTP_FORM_SUCCESS_MESSAGE:
            return Object.assign({}, state, {
                otpMessage: action.value,
                otpResponse: 1,
            });
        case SAVE_EMPLOYEE_GET_OTP_FORM_ERROR_MESSAGE:
            return Object.assign({}, state, {
                otpMessage: action.value,
                otpResponse: 2,
            });
        case SET_OPTIONAL_FORM_DATA:
            return Object.assign({}, state, {
                optData: action.value,
            });
        case SAVE_EMPLOYEE_ACCOUNT_FORM_SUCCESS_MESSAGE:
            return Object.assign({}, state, {
                s2Message: action.value,
                s2ResponseStatus: 1,
            });
        case SAVE_EMPLOYEE_ACCOUNT_FORM_WARNING_MESSAGE:
            return Object.assign({}, state, {
                s2Message: action.value,
                s2ResponseStatus: 1,

                s2WarningStatus: 1,
            });
        case SAVE_EMPLOYEE_ACCOUNT_FORM_INFO_MESSAGE:
            return Object.assign({}, state, {
                s2Message: action.value,
                s2InfoStatus: 1,
            });
        case SAVE_EMPLOYEE_DISCOUNT_FORM_INFO_MESSAGE:
            return Object.assign({}, state, {
                s5Message: action.value,
                s4InfoStatus: 1,
            });
        case SAVE_EMPLOYEE_ACCOUNT_FORM_ERROR_MESSAGE:
            return Object.assign({}, state, {
                s2Message: action.value,
                s2ResponseStatus: 2,
            });

        case GET_ZIPCODE:
            return Object.assign({}, state, {
                zipCodeData: action.value,
            });
        case SET_ZIPCODE:
            return Object.assign({}, state, {
                zipCodeData: action.value,
            });

        case SAVE_EMPLOYEE_DISCOUNT_FORM:
            return Object.assign({}, state, {
                optData: action.value,
            });

        case ZIPCODE_ERROR_MESSAGE:
            return Object.assign({}, state, {
                s4Message: action.value,
                s4ResponseStatus: 2,
            });
        case ZIPCODE_SUCCESS_MESSAGE:
            return Object.assign({}, state, {
                s4Message: action.value,
                s4ResponseStatus: 1,
            });
        case SAVE_EMPLOYEE_DISCOUNT_FORM_ERROR_MESSAGE:
            return Object.assign({}, state, {
                submitMessage: action.value,
                submitResponseStatus: 2,
            });
        case SAVE_EMPLOYEE_DISCOUNT_FORM_SUCCESS_MESSAGE:
            return Object.assign({}, state, {
                submitMessage: action.value,
                submitResponseStatus: 1,
            });

        case RESET_ZIPCODE:
            return {
                ...state,
                s4Message: "",
                s4ResponseStatus: 0,
                zipCodeData: {},
            };

        default:
            return state;
    }
};
export default employeeDiscountForm;
